import http from '@/utils/http';
import i18n from '@/main';

const baseUrl = '/carregamentos-navios';

async function downloadBlob({ fileName, url, type = 'application/zip' }) {
    try {
        const response = await http.get({
            url,
            lockScreen: false,
            responseType: 'blob'
        });
        const blob = new Blob([response.data], {
            type
        });
        const objectURL = window.URL.createObjectURL(blob);
        const link = document.createElement('a');

        link.href = objectURL;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(objectURL);
    } catch (error) {
        throw error;
    }
}

export default {
    async fetchRelatorios(filtro) {
        try {
            let query = `${baseUrl}?page=${filtro?.page || 0}&size=${
                filtro?.size || 10
            }`;

            if (filtro?.searchTerm) {
                query += `&search=${encodeURIComponent(filtro.searchTerm)}`;
            }

            if (filtro?.dataInicio) {
                query += `&dataInicio=${encodeURIComponent(filtro.dataInicio)}`;
            }

            if (filtro?.dataFim) {
                query += `&dataFim=${encodeURIComponent(filtro.dataFim)}`;
            }

            const response = await http.get({
                url: query,
                lockScreen: true,
                lockMessage: i18n.t('mensagens.sistema.carregando')
            });

            return response;
        } catch (error) {
            throw error;
        }
    },
    async fetchRelatorioById(params) {
        try {
            const id = params.id || '';
            if (!id) {
                throw new Error('ID do relatório é obrigatório');
            }
            const query = `${baseUrl}/${id}`;
            const response = await http.get({
                url: query,
                lockScreen: true,
                lockMessage: i18n.t('mensagens.sistema.carregando')
            });

            return response;
        } catch (error) {
            throw error;
        }
    },
    async fetchRelatorioCarsById(params) {
        try {
            const page = params.page || 0;
            const size = params.size || 10;
            const id = params.id || '';
            const search = params.search
                ? `&search=${encodeURIComponent(params.search)}`
                : '';

            if (!id) {
                throw new Error('ID do relatório é obrigatório');
            }
            const query = search
                ? `${baseUrl}/${id}/cars?page=${page}&size=${size}&search=${search}`
                : `${baseUrl}/${id}/cars?page=${page}&size=${size}`;

            const response = await http.get({
                url: query,
                lockScreen: true,
                lockMessage: i18n.t('mensagens.sistema.carregando')
            });

            return response;
        } catch (error) {
            throw error;
        }
    },
    async fetchRelatorioContratosById(params) {
        try {
            const page = params.page || 0;
            const size = params.size || 10;
            const id = params.id || '';
            const search = params.search
                ? `&search=${encodeURIComponent(params.search)}`
                : '';

            if (!id) {
                throw new Error('ID do relatório é obrigatório');
            }
            const query = search
                ? `${baseUrl}/${id}/contratos?page=${page}&size=${size}&search=${search}`
                : `${baseUrl}/${id}/contratos?page=${page}&size=${size}`;

            const response = await http.get({
                url: query,
                lockScreen: true,
                lockMessage: i18n.t('mensagens.sistema.carregando')
            });

            return response;
        } catch (error) {
            throw error;
        }
    },
    async downloadRelatorioCar({ idNavio, idCar }) {
        try {
            const url = `${baseUrl}/${idNavio}/cars/${idCar}/relatorio`;

            await downloadBlob({
                url,
                fileName: `relatorio-car.pdf`,
                type: 'application/pdf'
            });
        } catch (error) {
            throw error;
        }
    },
    async downloadRelatorio(idNavio) {
        try {
            const url = `${baseUrl}/${idNavio}/relatorio`;
            await downloadBlob({
                url,
                fileName: `relatorio.zip`,
                type: 'application/zip'
            });
        } catch (error) {
            throw error;
        }
    },
    async downloadRelatorioContrato({ idNavio, idContrato }) {
        try {
            const url = `${baseUrl}/${idNavio}/contratos/${idContrato}/relatorio`;

            await downloadBlob({
                url,
                fileName: `relatorio-contrato.zip`,
                type: 'application/zip'
            });
        } catch (error) {
            throw error;
        }
    }
};
